import React, { useState, useRef } from 'react';
import api from '../api';
import { Col, Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import LoadingLogo from '../components/general/LoadingLogo';
import { Container } from 'react-bootstrap';
import ReCAPTCHA from 'react-google-recaptcha';

export default function ContactScreen() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState('');
  const recaptchaRef = useRef(null);

  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSubmitting) return; // prevents multiple submissions if already submitting

    if (!recaptchaToken) {
      toast.error(t('signup-screen-error-0-2'));
      return;
    }

    try {
      const { data: recaptchaResult } = await api.post(
        '/api/general/verify-recaptcha',
        { token: recaptchaToken }
      ); // sending the recaptchaToken to the backend for verification

      if (recaptchaResult.success) {
        setIsSubmitting(true);

        try {
          const { data: response } = await api.post(
            '/api/general/contact-form',
            formData
          );

          console.log('Contact Form Email sent successfully', response);
          toast.success(t('contact-screen-success'));
          navigate(`/`);
        } catch (error) {
          toast.error(t('contact-screen-error'));
          console.error('Error sending email:', error);
        } finally {
          setIsSubmitting(false);
        }
      } else {
        toast.error(t('contact-screen-error-2'));
        setRecaptchaToken('');
        recaptchaRef.current.reset(); // Reset the reCAPTCHA widget
      }
    } catch (error) {
      console.error('Error verifying reCAPTCHA:', error);
    }
  };

  const handleRecaptchaChange = (token) => {
    setRecaptchaToken(token);
  };

  return (
    <Container>
      <div className="container small-container">
        <title>{t('contact-screen-title')}</title>

        <h1 className="screen-heading">{t('contact-screen-heading')}</h1>

        <Row>
          <Col>
            <Form className="contact-form" onSubmit={handleSubmit}>
              <Form.Group
                className="contact-form-container"
                controlId="formName"
              >
                <Form.Label>{t('contact-screen-name')}</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  className="mobile-device-compatible"
                  value={formData.name}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group
                className="contact-form-container"
                controlId="formEmail"
              >
                <Form.Label>{t('contact-screen-e-mail')}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  className="mobile-device-compatible"
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group
                className="contact-form-container"
                controlId="formSubject"
              >
                <Form.Label>{t('contact-screen-subject')}</Form.Label>
                <Form.Control
                  type="text"
                  name="subject"
                  className="mobile-device-compatible"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              <Form.Group
                className="contact-form-container"
                controlId="formMessage"
              >
                <Form.Label>{t('contact-screen-message')}</Form.Label>
                <div className="contact-form-textarea-container">
                  <Form.Control
                    as="textarea"
                    name="message"
                    className="mobile-device-compatible-textarea"
                    value={formData.message}
                    onChange={handleChange}
                    maxLength={1000}
                    required
                  />
                </div>
                <Form.Text className="d-flex justify-content-end">
                  {`${formData.message.length}/1000`}
                </Form.Text>
              </Form.Group>
              <div className="recaptcha-container">
                <ReCAPTCHA
                  sitekey="6LfzWecpAAAAAIiYVpxC704EIzOF3C0rh0i1Jwq5"
                  onChange={handleRecaptchaChange}
                  ref={recaptchaRef}
                />
              </div>
              <div className="d-flex justify-content-center">
                <Button
                  variant="secondary"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting
                    ? t('contact-screen-sending')
                    : t('contact-screen-send')}
                </Button>

                {isSubmitting && (
                  <div className="overlay">
                    <LoadingLogo />
                  </div>
                )}
              </div>
            </Form>
          </Col>
        </Row>
      </div>
    </Container>
  );
}
